import { render, staticRenderFns } from "./h5Index.vue?vue&type=template&id=eff7c3f2&scoped=true&"
import script from "./h5Index.vue?vue&type=script&lang=js&"
export * from "./h5Index.vue?vue&type=script&lang=js&"
import style0 from "./h5Index.vue?vue&type=style&index=0&id=eff7c3f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff7c3f2",
  null
  
)

export default component.exports